/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/

import { useEffect, useState } from "react";
import { Box, Grid, Typography, CircularProgress, Card, CardContent } from "@mui/material";
import { callGetBocBalance } from "../../../../services/boc/BocController";
import { useTheme } from "@emotion/react";
import TransactionsPage from "./views/TransactionPage";
import BackButton from "../../../../components/shared/Buttons/BackButton";

const ViewBocPage = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const theme = useTheme();
    const fieldLabels = {
        ledgerBalance: "Ledger Balance",
        currentBalance: "Current Balance",
        availableBalance: "Available Balance",
        totalAccessibleBalance: "Total Accessible Balance",
        linkedAccountBalance: "Linked Account Balance",
        holdBalance: "Hold Balance",
    };
    const handleCall = async () => {
        setLoading(true);
        try {
            const result = await callGetBocBalance();
            setResponse(result?.response || null);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleCall();
    }, []);

    const renderCard = (title, value) => (
        <Card
            sx={{
                minWidth: 100,
                borderRadius: 3,
                boxShadow: 4,
                transition: "transform 0.2s, box-shadow 0.2s",
                background: theme.palette.background.dark,
                "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: 8,
                },
            }}
        >
            <CardContent sx={{ textAlign: "center" }}>
                <Typography variant="h6" color="text.secondary">
                    {fieldLabels[title] || title}
                </Typography>
                <Typography variant="h4" color="primary" sx={{ mt: 1, fontWeight: "bold" }}>
                    {value.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                    })}
                </Typography>
            </CardContent>
        </Card>
    );

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                <CircularProgress size={50} />
            </Box>
        );
    }

    return (
        <Box m={3}>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={12}>
                    <BackButton pageTitle={'View BOC Balances & Transactions.'} />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>

                     
                    {response ? (
                        <Grid container spacing={4}>
                            {Object.entries(response).map(([key, value]) => (
                                <Grid item xs={12} sm={6} md={2} key={key}>
                                    {renderCard(key, value)}
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Typography variant="body1" color="text.secondary">
                            No data available.
                        </Typography>
                    )}
                     <TransactionsPage startDate="" endDate="" />
                </Grid>

            </Grid>
        </Box>
    );
};

export default ViewBocPage;
